/**
 * Resolves the client domain from URL query params, environment variable, or hostname.
 * @returns {string}
 */
export const getClientDomain = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const domainParam = urlParams.get('domain');
    if (domainParam) {
        try {
            sessionStorage.setItem('client_domain', domainParam);
        } catch (e) {}
        return domainParam;
    }
    try {
        const cachedDomain = sessionStorage.getItem('client_domain');
        if (cachedDomain) {
            return cachedDomain;
        }
    } catch (e) {}
    return process.env.REACT_APP_CLIENT_DOMAIN || window.location.hostname;
};

